/**
 * WEBPACK_CONIFG_HOST的值，在webpack.config.js中更改
 * 开发环境时 = "http://amptest.wisedu.com/xsfwfw/"
 * 发布环境时 = location.origin + location.pathname.substring(0, location.pathname.indexOf("/", 1)) + "/"
 */

export default {
    userInfo: WEBPACK_CONFIG_HOST + '/sys/itservicecommon/api/queryAppAndUserDatas.do'
}



// WEBPACK FOOTER //
// ./src/api.js